import db from "../utils/firestore";
import { Collection } from "intake_shared/src/enum";
import { arrayRemove, arrayUnion } from "firebase/firestore";
import { ClinicianMethodology } from "intake_shared/src/types";

const METHODOLOGY_DOC = "options";

const SEED_VALUES = Object.values(ClinicianMethodology);

export async function getAllMethodologyOptions(): Promise<string[]> {
    const doc = await db
        .collection(Collection.METHODOLOGY)
        .doc(METHODOLOGY_DOC)
        .get();

    if (!doc.exists) {
        await db
            .collection(Collection.METHODOLOGY)
            .doc(METHODOLOGY_DOC)
            .set({ options: SEED_VALUES });
        return SEED_VALUES;
    }

    return doc.data()?.options ?? SEED_VALUES;
}

export async function addMethodologyOption(value: string): Promise<void> {
    if (/[./~*[\]]/.test(value)) {
        throw new Error(
            "Methodology option name cannot contain '.', '/', '~', '*', '[', or ']'"
        );
    }
    await db
        .collection(Collection.METHODOLOGY)
        .doc(METHODOLOGY_DOC)
        .update({ options: arrayUnion(value) });
}

export async function deleteMethodologyOption(value: string): Promise<void> {
    const cliniciansCollection = db.collection(Collection.CLINICIANS);

    const snapshot = await cliniciansCollection
        .where("methodology", "array-contains", value)
        .get();

    const CHUNK_SIZE = 400;
    const docs = snapshot.docs;

    for (let i = 0; i < docs.length; i += CHUNK_SIZE) {
        const chunk = docs.slice(i, i + CHUNK_SIZE);
        const batch = db.batch();
        chunk.forEach((doc) => {
            batch.update(doc.ref, {
                methodology: arrayRemove(value),
                [value]: false,
            });
        });
        await batch.commit();
    }

    await db
        .collection(Collection.METHODOLOGY)
        .doc(METHODOLOGY_DOC)
        .update({ options: arrayRemove(value) });
}
